import { Box, makeStyles, Typography } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import React from "react";

import { CustomButton } from "@/components/Button";
import { layoutTokens as layout, semanticColors as colors, textStyles } from "@/designTokens";
import theme from "@/theme";

const useStyles = makeStyles({
  loading: {
    display: "grid",
    gap: layout.space[24],
    [theme.breakpoints.up("md")]: { gridTemplateColumns: "minmax(0,384fr) minmax(0,776fr)", gap: layout.space[40] },
  },
  card: { background: colors["surface/card"], padding: layout.space[24], borderRadius: layout.radius.lg, minWidth: 0 },
  error: {
    maxWidth: 560,
    margin: "0 auto",
    padding: layout.space[32],
    borderRadius: layout.radius.lg,
    background: colors["surface/card"],
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: layout.space[24],
    textAlign: "center",
  },
});
export const BalanceLoading = () => {
  const classes = useStyles();
  return (
    <Box className={classes.loading} aria-label="収支を読み込み中" role="status">
      {[0, 1].map((column) => (
        <Box className={classes.card} key={column}>
          <Skeleton width="60%" height={24} />
          <Skeleton width="80%" height={32} />
          <Skeleton variant="rect" height={column === 0 ? 140 : 160} />
          <Skeleton width="90%" height={24} />
        </Box>
      ))}
    </Box>
  );
};
export const BalanceError: React.FC<{ onRetry?: () => void }> = ({ onRetry = () => window.location.reload() }) => {
  const classes = useStyles();
  return (
    <Box className={classes.error} role="alert">
      <Typography component="h2" style={textStyles["SP/Heading/H3"]}>
        収支を読み込めませんでした
      </Typography>
      <Typography style={{ ...textStyles["SP/Body/Large"], color: colors["text/secondary"] }}>
        通信状況を確認して、もう一度お試しください。
      </Typography>
      <CustomButton tone="outline" buttonSize="M" onClick={onRetry}>
        再読み込み
      </CustomButton>
    </Box>
  );
};
